export interface CompanyProfileIdentity {
  id: string;
}

export function resolveSelectedCompanyProfileId(
  profiles: ReadonlyArray<CompanyProfileIdentity>,
  requestedId?: string | null,
  activeId?: string | null,
): string | undefined {
  if (requestedId && profiles.some((profile) => profile.id === requestedId)) {
    return requestedId;
  }
  if (activeId && profiles.some((profile) => profile.id === activeId)) {
    return activeId;
  }
  return profiles[0]?.id;
}
